import { getUserAccountInfo } from "../../../getUserAccountInfo/dev";
import { getContent } from "../../../getContent/dev";
import { getSendSbpPayment } from "./logic.quick";
export var sendSbpPayment = getSendSbpPayment({
  getUserAccountInfo: getUserAccountInfo,
  isSmsResend: false,
  getContent: getContent
});